class MFRGrid {
    constructor( i, e, args ) {
        this.$index = i;
        this.$element = $( e );
        this.args = args;

        this.ease = "back";

        this.init();
    }

    init() {
        this.$item = this.$element.find( this.args.item );
        this.$itemWrapper = this.$element.find( this.args.itemWrapper );
        this.$filter = this.$element.find( this.args.filter );
        // gsap.set( this.$itemWrapper, { height: this.$itemWrapper.height() } );

        this.$filter.on( "click", this.__handleFilterClick.bind( this ) );
    }

    __handleFilterClick( e ) {
        const filter = $( e.currentTarget );
        if( filter.hasClass( "is-active" ) ) return;
        this.$filter.removeClass( "is-active" );

        filter.addClass( "is-active" );

        this.updateItems( filter.data( this.args.filterAttribute ) );
    }

    updateItems( filter ) {
        const itemState = Flip.getState( this.$item );
        const wrapperState = Flip.getState( this.$itemWrapper, { props: "height" } );
        if( filter == "*" ) {
            this.$item.css( "display", "block" );
        }
        else if( !filter ) { 
            return;
        }
        else {
            this.$item.css( "display", "none" );
            this.$element.find( `${ this.args.item }.${ this.args.filterPrefix }${ filter }` ).show();
        }

        // window.smoother.paused( true );

        Flip.from(itemState, {
            duration: .4,
            scale: true,
            absoluteOnLeave: true,
            ease: this.ease,
            stagger: 0.1,
            onEnter: elements => gsap.fromTo(elements, {opacity: 0, scale: 0}, {opacity: 1, scale: 1, duration: 0.4}),
            onLeave: elements => gsap.to(elements, {opacity: 0, scale: 0, duration: 0.4})
        });
        Flip.from( wrapperState, {
            duration: .4,
            scale: false
        } )
        setTimeout( () => {
            // window.smoother.paused( false );
            ScrollTrigger.refresh()
        }, 400 );
    }
}